import {
  AnalyticsEvent,
  OpenPdfUrlAction,
  SdLaunchAdvanceAccountNavigation,
  SdLaunchAdvanceOnboardingNavigation,
  SdLaunchBelieveOnboardingNavigation,
  SdLaunchBelieveTransferFundsNavigation,
  SdLaunchVlocNavigation,
  Typenames,
} from '@varo/graphql-schema-types';
import { RouteInputParams, RoutePath } from 'expo-router';
import { Maybe } from 'shared/utils/types';

type GenericRouteAction<T extends RoutePath> = {
  pathname: T;
  params?: RouteInputParams<T> | { id?: string } | { name?: string };
  analyticsEvent: Maybe<AnalyticsEvent>;
};

type GenericActionRoutes =
  | '/varo-line-of-credit/line-of-credit-entry-point'
  | '/varo-advance'
  | `/move-money/direct-deposit`
  | `/varo-advance/not-qualified`
  | `/believe/apply`
  | `/move-money/transfer/transfer-money`
  | `/document/pdf`
  | `/move-money/direct-deposit/direct-deposit-management`;

const launchVLOCAction = ({
  analytics,
}: SdLaunchVlocNavigation): GenericRouteAction<GenericActionRoutes> => {
  return {
    pathname: '/varo-line-of-credit/line-of-credit-entry-point',
    analyticsEvent: analytics,
  };
};

const launchAdvanceOnboardingAction = ({
  analytics,
}: SdLaunchAdvanceOnboardingNavigation): GenericRouteAction<GenericActionRoutes> => {
  return {
    pathname: '/varo-advance',
    analyticsEvent: analytics,
  };
};

const launchAdvanceAccountAction = ({
  id,
  analytics,
}: SdLaunchAdvanceAccountNavigation): GenericRouteAction<GenericActionRoutes> => {
  return {
    pathname: `/varo-advance`,
    params: { id: id },
    analyticsEvent: analytics,
  };
};

const launchBelieveOnboardingNavigation = ({
  analytics,
}: SdLaunchBelieveOnboardingNavigation): GenericRouteAction<GenericActionRoutes> => {
  return {
    pathname: `/believe/apply`,
    analyticsEvent: analytics,
  };
};

const launchBelieveTransferFundsNavigation = ({
  analytics,
}: SdLaunchBelieveTransferFundsNavigation): GenericRouteAction<GenericActionRoutes> => {
  return {
    pathname: `/move-money/transfer/transfer-money`,
    analyticsEvent: analytics,
  };
};

const launchPdfDocument = ({
  analyticsEvent,
}: OpenPdfUrlAction): GenericRouteAction<GenericActionRoutes> => {
  return {
    pathname: `/document/pdf`,
    analyticsEvent: analyticsEvent,
  };
};

export type UnknownGQLType = {
  __typename?: Maybe<string>;
  // allow any gql type to be passed in here. it will be handled if it's a valid action.

  [prop: string]: any;
};

// JT-125443 - Evaluate migrating Advance nav to use RouteNavigationAction
export const genericRouteAction = (
  action: UnknownGQLType,
): Maybe<GenericRouteAction<GenericActionRoutes>> => {
  switch (action.__typename) {
    case Typenames.SDLaunchVLOCNavigation:
      return launchVLOCAction(action as SdLaunchVlocNavigation);
    case Typenames.SDLaunchAdvanceOnboardingNavigation:
      return launchAdvanceOnboardingAction(
        action as SdLaunchAdvanceOnboardingNavigation,
      );
    case Typenames.SDLaunchAdvanceAccountNavigation:
      return launchAdvanceAccountAction(
        action as SdLaunchAdvanceAccountNavigation,
      );
    case Typenames.SDLaunchBelieveOnboardingNavigation:
      return launchBelieveOnboardingNavigation(
        action as SdLaunchBelieveOnboardingNavigation,
      );
    case Typenames.SDLaunchBelieveTransferFundsNavigation:
      return launchBelieveTransferFundsNavigation(
        action as SdLaunchBelieveTransferFundsNavigation,
      );
    case Typenames.OpenPdfUrlAction:
      return launchPdfDocument(action as OpenPdfUrlAction);
    default:
      return null;
  }
};
